<template>
  <div>
    <Heade>
      <template v-slot:back ><img src="../../assets/img/02-2左new.png" alt="" @click="$router.push('/')"></template>
      <template v-slot:title>会议签到</template>
    </Heade>
    <div v-if="goSign">
       <div class="myStandName">
        <div><img src="../../assets/img/jxflogo.png" alt=""></div>
        <div class="myStandName_txt">急先锋-{{meetingName}}</div>
      </div>

      <div class="F_tab">
        <div class="content">
          <div class="tab"
          v-for="(item,index) in unitList" 
          :key="index" 
          @click="handleTab(item,index)"
          :class="index==tabIndex?'choose':''">{{item}}</div>
        </div>
      </div>
      

      <div >
        <van-form @submit="onSubmit" validate-first label-width="140" input-align="right" error-message-align="right">
          <div class="container" v-if="isShow">
            <van-field
              v-model="formData.mName"
              type="text"
              :left-icon="name"
              required
              name="姓名"
              label="姓名"
              placeholder="请输入"
              :rules="[{ required: true, message: '请填写姓名' }]"
            />

            <fsySelect label="性别" :columns="ageList" @getdata="getAge" :name="sex" :defaultValue="formData.gender"></fsySelect>

            <van-field
              v-model="formData.age"
              type="number"
              required
              :left-icon="age"
              name="年龄"
              label="年龄"
              maxlength="3"
              placeholder="请输入"
              :rules="[{ required: true, message: '请填写年龄' }]"
            />

            <van-field
              v-model="formData.linkPhone"
              type="number"
              required
              :left-icon="phone"
              name="联系方式"
              label="联系方式"
              maxlength="11"
              placeholder="请输入"
              :rules="[{ validator:phoneValidator, message: '请填写正确联系方式' }]"
            />

            <van-field
              v-model="formData.IdCard"
              type="number"
              required
              :left-icon="Id"
              name="身份证号"
              maxlength="20"
              label="身份证号"
              placeholder="请输入"
              :rules="[{ required: true, message: '请填写身份证号' }]"
            />

            <fsySelect label="省" :columns="provinceList" @getdata="getProvince" valueKey='z_name' :name="province" :defaultValue="formData.province"></fsySelect>

            <fsySelect label="市" :columns="cityList" @getdata="getCity" valueKey='z_name' :name="province" :defaultValue="formData.municipality"></fsySelect>

            <fsySelect label="县/区" :columns="districtList" @getdata="getDistrict" valueKey='z_name' :name="province" :defaultValue="formData.zone"></fsySelect>

            <van-field
              v-model="formData.company"
              type="text"
              required
              :left-icon="unit"
              name="工作单位"
              maxlength="20"
              label="工作单位"
              placeholder="请输入"
              :rules="[{ required: true, message: '请填写工作单位' }]"
            />

            <fsySelect label="科室" :columns="section" @getdata="getSection" :name="administrative" :defaultValue="formData.department"></fsySelect>

            <fsySelect label="职称" :columns="Rank" @getdata="getRank" :name="designation" :defaultValue="formData.mTitle"></fsySelect>

            <fsySelect label="职务" :columns="dutyList" @getdata="getDuty" :name="duty" :defaultValue="formData.mPost"></fsySelect>
            

              <van-field
              v-model="formData.eMail"
              type="text"
              required
              :left-icon="EMail"
              name="电子邮箱"
              label="电子邮箱"
              placeholder="请输入"
              :rules="[{ validator, message: '请填写正确电子邮箱' }]"
            />

            <div class="question">
              <div class="titleName"><span class="wire"></span>相关问题</div>
              <div class="issue_1">
                <div class="title">1.您所在的医院是否开展溶栓</div>
                <fsyRadio :radioList="thrombolysis" @handleRadio="getThrombolysis" :defaultValue="formData.problemOne"></fsyRadio>
              </div>

              <div class="issue_1" v-if="formData.problemOne == '是'">
                <div class="title">2.您所在的医院溶栓常规用药</div>
                <fsyRadio :radioList="routine" @handleRadio="getRoutine" :defaultValue="formData.problemTwo" :text="formData.text"></fsyRadio>
              </div>

              <div class="issue_1">
                <div class="title"><span>{{formData.problemOne=="是" ? 3 : 2}}</span>.是否来自基础医院<span>(县级以下,社区等医疗卫生机构)</span></div>
                <fsyRadio :radioList="thrombolysis" @handleRadio="getSource" :defaultValue="formData.problemThree"></fsyRadio>
              </div>
            </div>
          </div>

          <div class="container" v-if="!isShow">
            <van-field
              v-model="formData.mName"
              type="text"
              required
              :left-icon="name"
              name="姓名"
              label="姓名"
              placeholder="请输入姓名"
              :rules="[{ required: true, message: '请填写姓名' }]"
            />

            <van-field
              v-model="formData.linkPhone"
              type="text"
              required
              :left-icon="phone"
              name="联系方式"
              label="联系方式"
              placeholder="请输入联系方式"
              :rules="[{ required: true, message: '请填写联系方式' }]"
            />

            <van-field
              v-model="formData.company"
              type="text"
              required
              :left-icon="unit"
              name="工作单位"
              label="工作单位"
              placeholder="请输入工作单位"
              :rules="[{ required: true, message: '请填写工作单位' }]"
            />

          </div>

          <div class="btn">
            <van-button round block type="info" native-type="submit">
              提交登记
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

     <!--选择会议提示框  :disabled="item.sigin_id?true:false"-->
    <div class="selectHuiyi" v-if="isMeeting">
        <div class="MengchengBg"></div>
        <div class="Mengcheng_con">
            <div class="Mengcheng_top">
                <div><img src="../../assets/img/diandiandain111.png" alt=""></div>
                <div>请选择签到的会议</div>
            </div>
            <div id="mySelectHuiyi">
              <van-radio-group v-model="radio">
                  <van-radio 
                  :name="item" 
                  v-for="(item,index) in MeetingList"
                  
                  :key="index" 
                  class="f_radio" 
                  checked-color="#2d5ea7"> {{item.meeting_place}}<span class="sign">{{item.sigin_id ? '已签到':'未签到'}}</span></van-radio>
              </van-radio-group>
            </div>
            <div class="selectHuiyiJX" @click="meetingForward">继续</div>
        </div>
    </div>

     <!--没有会议-->
    <div class="selectHuiyi" v-if="noneMeeting">
        <div class="MengchengBg"></div>
        <div class="Mengcheng_con">
            <div class="Mengcheng_top">
                <div><img src="../../assets/img/diandiandain111.png" alt=""></div>
                <div>提示</div>
            </div>
            <div id="mySelectHuiyi">
              <div class="text">现在没有会议,请关注下场会议开始时间！</div>
            </div>
            <div class="selectHuiyiJX" @click="$router.push('/')">确定</div>
        </div>
    </div>

    <div id="allmap"></div>
   

  </div>
</template>
<script>
import name from "../../assets/img/02-姓名icon@2x.png";
import phone from "../../assets/img/02-联系方式icon@2x.png";
import Id from "../../assets/img/02-身份证icon@2x.png";
import unit from "../../assets/img/02-工作单位icon@2x.png";
import administrative from "../../assets/img/02-科室icon@2x.png";
import duty from "../../assets/img/02-职务icon@2x.png";
import designation from "../../assets/img/02-职称icon@2x.png";
import EMail from "../../assets/img/02-电子邮箱icon@2x.png";
import sex from "../../assets/img/02-x性别 icon.png";
import age from "../../assets/img/02-x年龄 icon.png";
import province from "../../assets/img/02-x省市 icon.png";
import { Toast } from "vant";
import {
  ageList,
  whether,
  routine,
  section,
  Rank,
  dutyList
} from "./arrayList";
export default {
  data() {
    return {
      name: name,
      phone: phone,
      Id: Id,
      unit: unit,
      duty: duty,
      EMail: EMail,
      province: province,
      sex: sex,
      age: age,
      designation: designation,
      administrative: administrative,
      unitList: ["医疗单位", "非医疗单位"],
      isShow: true,
      tabIndex: 0,
      formData: {
        weixin: sessionStorage.getItem("openid"),
        lng: "",
        lat: "",
        medical_unit_flag: "是",
        mName: "",
        linkPhone: "",
        IdCard: "",
        company: "",
        department: "",
        mTitle: "",
        mPost: "",
        eMail: "",
        problemOne: "",
        problemTwo: "",
        problemThree: "",
        gender: "",
        age: "",
        JicengFlag: "",
        province: "",
        municipality: "",
        zone: ""
      },
      thrombolysis: whether,
      routine: routine,
      section: section,
      Rank: Rank,
      dutyList: dutyList,
      provinceList: [],
      cityList: [],
      districtList: [],
      ageList: ageList,
      noneMeeting: false, //没有会议
      isMeeting: false, //会议选择开关
      MeetingList: [], //会议列表
      radio: "", //选中的会议
      goSign: false,
      meetingName: ''
    };
  },
  //接收来自父组件的数据
  props: {},
  //生命周期实例创建完成后被立即调用
  created() {
    this.radio = this.$route.query.queryRadio
    console.log("radio",this.radio)
  },
  //生命周期挂载完成之后被调用
  mounted() {
    // const openid = sessionStorage.getItem("openid");
    const openid = this.$store.state.openId
    console.log('signopenid',openid)
    this.getMap();
    this.getprovinceList();
    if (openid) {
      this.getUserMsg(openid);      
      this.radio ? this.meetinggoSign() : this.isJurisdiction(openid);
    }
  },
  //组件
  components: {},
  //方法
  methods: {
    //百度地图获取定位
    getMap() {
      const _this = this;
      const map = new BMap.Map("allmap");
      const point = new BMap.Point(116.331398, 39.897445);
      map.centerAndZoom(point, 12);

      const geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          const mk = new BMap.Marker(r.point);
          map.addOverlay(mk);
          map.panTo(r.point);
          _this.formData.lng = r.point.lng;
          _this.formData.lat = r.point.lat;
        } else {
          console.log("failed" + this.getStatus());
        }
      });
    },
    //获取签到人最近一次的基本信息
    getUserMsg(openid) {
      const url = "/getOldSiginInfo";
      this.axios.post(url, { weixin: openid }).then(res => {
        if (res.data.code === "00000") {
          //console.log(res);
          const data = res.data.model;
          this.getProvince({ z_name: data.province, id: data.province_id });
          this.getCity({ z_name: data.municipality, id: data.municipality_id });
          this.formData.medical_unit_flag = data.medical_unit_flag;
          if (data.medical_unit_flag == "是") {
            this.tabIndex = 0;
            this.isShow = true;
          } else {
            this.tabIndex = 1;
            this.isShow = false;
          }
          this.formData.mName = data.m_name ? data.m_name : "";
          this.formData.age = data.age ? data.age : "";
          this.formData.linkPhone = data.link_phone ? data.link_phone : "";
          this.formData.IdCard = data.idcard ? data.idcard : "";
          this.formData.gender = data.gender;
          this.formData.provinceID = data.province_id;
          this.formData.province = data.province;

          setTimeout(() => {
            this.$set(this.formData, "municipalityID", data.municipality_id);
            this.$set(this.formData, "municipality", data.municipality);
            this.$set(this.formData, "zoneID", data.zone_id);
            this.$set(this.formData, "zone", data.zone);
          }, 300);

          this.formData.company = data.company;
          this.formData.department = data.department;
          this.$set(this.formData, "mTitle", data.m_title);
          this.$set(this.formData, "mPost", data.m_post);
          this.formData.eMail = data.e_mail ? data.e_mail : "";
          this.$set(this.formData, "problemOne", data.problem_one);
          if (data.problem_two && data.problem_two !== "其他") {
            this.$set(this.formData, "problemTwo", "其他");
            this.$set(this.formData, "text", data.problem_two);
          }
          this.$set(this.formData, "problemThree", data.problem_three);
          // console.log(this.formData)
        }
      });
    },
    //可签到会议列表
    isJurisdiction(openid) {
      const url = "/canSiginMeetingList";
      this.axios.post(url, { weixin: openid, meetingType: 2 }).then(res => {
        if (res.data.code === "00000") {
          //console.log(res);
          const list = res.data.model;
          if (list.length > 1) {
            this.isMeeting = true;
            this.MeetingList = list;
          } else if (list.length == 1) {
            this.isMeeting = false;
            this.$set(this.formData, "meeting_field", list[0].meeting_field);
            const sigin_id = list[0].sigin_id; //已经签到的标记
            if (sigin_id) {
              setTimeout(() => {
                console.log(list[0].online_meeting_url);
                //window.open(list[0].online_meeting_url);
                window.location = list[0].online_meeting_url;
              }, 1000);
            }else{
              this.$set(this.formData, "meeting_field", list[0].meeting_field);
              this.goSign = true;
              this.meetingName =  list[0].meeting_name
            }
          } else {
            this.noneMeeting = true;
          }
        }
      });
    },
    meetinggoSign(){
      this.$set(this.formData, "meeting_field", this.radio.meeting_field);
      this.isMeeting = false;
      this.goSign = true;
      this.meetingName =  this.radio.meeting_name
    },
    //会议选择完点击继续
    meetingForward() {
      if (this.radio) {
        console.log("radio",this.radio)
        if(this.radio.sigin_id){
          window.location = this.radio.online_meeting_url;
        }else{          
          this.$set(this.formData, "meeting_field", this.radio.meeting_field);
          this.isMeeting = false;
          this.goSign = true;
          this.meetingName =  this.radio.meeting_name
        }
      } else {
        Toast("请选择会议");
        // this.$router.push("/Live");
      }
    },
    //根据父级查询所有子集行政区域
    getprovinceList(parentCode = "") {
      const url = "/api/company/getAllProvince";
      this.axios.post(url).then(res => {
        if (res.data.code === "00000") {
          this.provinceList = res.data.model;
        }
      });
    },
    //获取省数据
    getProvince(value) {
      this.$set(this.formData, "province", value.z_name);
      this.$set(this.formData, "provinceID", value.id);
      const url = "/api/company/getAllCity";
      this.axios.post(url, { provinceId: value.id }).then(res => {
        if (res.data.code === "00000") {
          this.cityList = res.data.model;
          this.$set(this.formData, "municipality", "");
          this.$set(this.formData, "municipalityID", "");
          this.$set(this.formData, "zone", "");
          this.$set(this.formData, "zoneID", "");
          this.districtList = [];
        }
      });
    },
    //获取市数据
    getCity(value) {
      this.$set(this.formData, "municipality", value.z_name);
      this.$set(this.formData, "municipalityID", value.id);
      const url = "/api/company/getAllCounty";
      this.axios.post(url, { cityId: value.id }).then(res => {
        if (res.data.code === "00000") {
          this.districtList = res.data.model;
          this.$set(this.formData, "zone", "");
          this.$set(this.formData, "zoneID", "");
        }
      });
    },
    //获取区县数据
    getDistrict(value) {
      this.$set(this.formData, "zone", value.z_name);
      this.$set(this.formData, "zoneID", value.id);
    },
    //获取性别数据
    getAge(value) {
      this.$set(this.formData, "gender", value.name);
    },
    //获取科室
    getSection(value) {
      this.$set(this.formData, "department", value.name);
    },
    //获取职称
    getRank(value) {
      this.$set(this.formData, "mTitle", value.name);
    },
    //获取职务
    getDuty(value) {
      this.$set(this.formData, "mPost", value.name);
    },
    //选中单位类型
    handleTab(item, index) {
      if (index == 0) {
        this.isShow = true;
        this.$set(this.formData, "medical_unit_flag", "是");
      } else {
        this.isShow = false;
        this.$set(this.formData, "medical_unit_flag", "否");
      }
      this.tabIndex = index;
    },
    //您所在的医院是否开展溶栓
    getThrombolysis(val) {
      this.$set(this.formData, "problemOne", val);
    },
    //您所在的医院溶栓常规用药
    getRoutine(val, text) {
      if (val == "其他") {
        this.$set(this.formData, "text", text);
      } else {
        this.$set(this.formData, "problemTwo", val);
      }
    },
    //是否来自基础医院
    getSource(val) {
      this.$set(this.formData, "problemThree", val);
    },
    //提交
    onSubmit() {
      console.log('oooo',this.formData);
      if (
        this.formData.problemOne &&
        !this.formData.problemTwo &&
        !this.formData.text
      ) {
        Toast("请选择您所在的医院溶栓常规用药");
        return false;
      } else if (this.formData.text) {
        this.$set(this.formData, "problemTwo", this.formData.text);
      }
      const url = "/siginIn";
      this.axios.post(url, this.formData).then(res => {
        console.log(res);
        if (res.data.code === "00000") {
          //window.open(res.data.online_meeting_url);
          window.location = res.data.online_meeting_url;
          Toast.success("成功");
        } else {
          Toast.success(res.data.msg);
        }
      });
    },
    // 名字验证
    verifyName(val) {
      console.log(val);
      var nameReg = /^[\u4E00-\u9FA5]{2,4}$/;
      return nameReg.test(val);
    },
    // 电话验证
    phoneValidator(val) {
      console.log(val);
      return /^1[3456789]\d{9}$/.test(val);
    },
    //验证邮箱
    validator(val) {
      console.log(val);
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      return reg.test(val);
    }
  },
  //监视
  watch: {}
};
</script>
<style lang="less" scoped>
.F_tab {
  margin: 30px 0;
  box-sizing: border-box;
  padding: 0 40px;
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #2d5ea7;
    border-radius: 8px;
    .tab {
      width: 335px;
      height: 74px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      color: #2d5ea7;
    }
    .choose {
      background: #2d5ea7;
      color: #ffffff;
      border-radius: 8px;
    }
  }
}
.myStandName {
  margin-top: 30px;
  width: 100%;
  height: 95px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 62px;
    height: 62px;
  }
  .myStandName_txt {
    font-size: 34px;
    margin-left: 8px;
  }
}
.btn {
  margin: 30px 0 80px 0;
  button {
    width: 80%;
    margin: auto;
    background: #2d5ea7;
    border-radius: 18px;
  }
}
.question {
  width: 100%;
  margin-top: 20px;
  .titleName {
    width: 100%;
    box-sizing: border-box;
    padding: 0 30px;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #333333;
    margin-bottom: 20px;
    .wire {
      display: inline-block;
      width: 6px;
      height: 26px;
      background: #f52b06;
      border: 4px;
      margin-right: 20px;
    }
  }
  .issue_1 {
    width: 100%;
    background: #ffffff;
    margin-bottom: 20px;
    .title {
      box-sizing: border-box;
      padding: 20px;
      border-bottom: solid 1px #e5e5e5;
      font-size: 30px;
      color: #333333;
      span {
        font-size: 24px;
      }
    }
  }
}
.selectHuiyi {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .MengchengBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.3;
    z-index: -1;
  }
  .Mengcheng_con {
    width: 520px;
    height: 553px;
    background-color: white;
    border-radius: 20px;
    margin: auto;
    margin-top: 40%;
    .Mengcheng_top {
      width: 100%;
      height: 255px;
      border-radius: 8px 8px 0 0;
      /* background: url("../../images/qt/landi.png") no-repeat center; */
      background: #007aff;

      background: -webkit-linear-gradient(left top, #78c4ff, #007aff);

      background: -moz-linear-gradient(left top, #78c4ff, #007aff);

      background: -ms-linear-gradient(left top, #78c4ff, #007aff);

      background: -o-linear-gradient(left top, #78c4ff, #007aff);

      background: linear-gradient(to left top, #78c4ff, #007aff);
      background-size: 100% 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      img {
        width: 77px;
        height: 12px;
      }
      div {
        font-size: 36px;
        color: white;
        margin-top: 20px;
      }
    }
    #mySelectHuiyi {
      height: 300px;
      overflow: auto;
      background-color: white;
      .text {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        box-sizing: border-box;
        padding: 0 30px;
        letter-spacing: 5px;
      }
      /deep/.van-radio {
        box-sizing: border-box;
        padding: 20px 20px 20px 30px;
        border-bottom: solid 1px #e5e5e5;
      }
      /deep/.van-cell {
        width: 100%;
        padding: 0;
      }
      /deep/.van-field__value {
        width: 100%;
      }
      /deep/.van-radio-group {
        width: 100%;
      }
      .sign {
        margin-left: 10px;
        display: inline-block;
        width: 70px;
        height: 25px;
        background: #fd2f8b;

        background: -webkit-linear-gradient(left top, #fd2f8b, #fc5d31);

        background: -moz-linear-gradient(left top, #fd2f8b, #fc5d31);

        background: -ms-linear-gradient(left top, #fd2f8b, #fc5d31);

        background: -o-linear-gradient(left top, #fd2f8b, #fc5d31);

        background: linear-gradient(to left top, #fd2f8b, #fc5d31);
        border-radius: 4px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 25px;
      }
    }
    .selectHuiyiJX {
      width: 100%;
      height: 70px;
      font-size: 32px;
      color: white;
      background-color: #1d8eff;
      border-radius: 0 0 20px 20px;
      text-align: center;
      line-height: 70px;
    }
  }
}
</style>